import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../layout/PageHeader";
import { FiPlus } from "react-icons/fi";

/**
 * CrudListPage - Reusable wrapper for list/table pages
 *
 * @param {string} title - Page title
 * @param {string} addLink - URL for "Add New" button
 * @param {string} addLabel - Label for add button (default: "Add New")
 * @param {array} breadcrumb - Breadcrumb items [{label, to}]
 * @param {node} filters - Optional filter components
 * @param {node} actions - Additional action buttons
 * @param {node} children - Table or content
 * @param {string} variant - Style variant: "default" | "v4"
 * @param {ReactElement} icon - Optional icon for V4 PageHeader
 */
const CrudListPage = ({
	title,
	addLink,
	addLabel = "Add New",
	breadcrumb = [],
	filters,
	actions,
	children,
	variant = "default",
	icon,
}) => {
	const headerActions = (
		<>
			{actions}
			{addLink && (
				<Link to={addLink} className="btn btn--primary">
					<FiPlus style={{ marginRight: 6 }} />
					{addLabel}
				</Link>
			)}
		</>
	);

	const pageClass = `crud-page crud-list ${variant === "v4" ? "crud-page--v4" : ""}`;
	const isV4 = variant === "v4";

	return (
		<div className={pageClass}>
			<PageHeader
				title={title}
				breadcrumb={isV4 ? [] : breadcrumb}
				filters={filters}
				actions={headerActions}
				v4={isV4}
				icon={icon}
			/>

			{children}
		</div>
	);
};

export default CrudListPage;
